import { getCookies, setCookie } from 'lib/web/cookieUtils'

const ATTRACTION_ATTRIBUTION_COOKIE = 'le_attr'
const ATTRIBUTION_TTL_SECONDS = 7 * 24 * 60 * 60

export interface AttractionAttribution {
  id: string
  name: string
  destination: string
  timestamp: number
}

export function setAttractionAttribution(
  id: string,
  name: string,
  destination: string,
): void {
  const value = JSON.stringify({ id, name, destination, timestamp: Date.now() })
  setCookie(ATTRACTION_ATTRIBUTION_COOKIE, value, ATTRIBUTION_TTL_SECONDS, '/', 'Lax')
}

export function getAttractionAttribution(): AttractionAttribution | null {
  const cookies = getCookies()
  const raw = cookies[ATTRACTION_ATTRIBUTION_COOKIE]
  if (!raw) return null
  try {
    return JSON.parse(decodeURIComponent(raw)) as AttractionAttribution
  } catch {
    return null
  }
}

export function clearAttractionAttribution(): void {
  setCookie(ATTRACTION_ATTRIBUTION_COOKIE, '', 0, '/', 'Lax')
}
